import * as React from "react";
const SvgFilter = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 12, viewBox: "0 0 18 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 6H14M1.5 1H16.5M6.5 11H11.5", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgFilter;
